import * as React from 'react';
import DBService from '../../Service/DBService';
import { filesize } from 'filesize';
import { GlobalContext } from "../../Contexts/GlobalContext";
import { isNativeApp } from '../../Dependency/NativeAppMemory';

interface TestIndexedDbState{
  showMedia: boolean;
  mediaData: any;
  nbImages: number;
  mediaSize?: number;
  nbRecords?: number;
  storageData?: any;
  error?: any;
  progress?: any;
}

export default class TestIndexedDb extends React.Component<any, TestIndexedDbState>{
  static contextType = GlobalContext;
  declare context: React.ContextType<typeof GlobalContext>;

  private mediaUrl: string = './dist/test/test-image.jpeg';
  private dbService: any;

  constructor(props: any) {
    super(props);
    this.fetchImages = this.fetchImages.bind(this);
    this.getMediaData = this.getMediaData.bind(this);
    this.resetDb = this.resetDb.bind(this);
    this.dbService = DBService;

    this.state = {
      showMedia: false,
      mediaData: undefined,
      nbImages: 10,
      mediaSize: undefined,
      nbRecords: undefined,
      storageData: undefined,
      error: undefined,
      progress: undefined,
    }
  }

  async componentDidMount() {
    // The app keeps the queue in its own store: this page is a browser tool
    if (isNativeApp()) {
      return;
    }

    await this.dbService.openDb();
    this.setState({
      nbRecords: await this.dbService.countRecords('test'),
      storageData: navigator.storage && await navigator.storage.estimate()
    })
  }

  async fetchImages() {
    this.dbService.openDb();
    await fetch(this.mediaUrl)
      .then(response => response.blob())
      .then(async (blob) => {
        const { nbImages } = this.state;
        for (let i = 0; i < nbImages; i++) {
          this.dbService.putValue('test', blob)
          this.setState({ progress: `please wait...` })
        }
        this.setState({
          nbRecords: await this.dbService.countRecords('test'),
          storageData: navigator.storage && await navigator.storage.estimate(),
          progress: undefined,
        })
      })
      .catch((err: any) => { console.error(err); this.setState({ error: err })});
  }

  getMediaData() {
    this.dbService.getAllValue('test')
      .then((values: any) => {
        this.setState({
          mediaData: values.map((value: any) => URL.createObjectURL(value)),
          showMedia: true,
        })
      })
      .catch((err: any) => { console.error(err); this.setState({ error: err })});
  }

  async resetDb() {
    this.setState({ progress: 'deleting db...' })
    setTimeout(() => this.setState({ progress: 'db deleted, please reload page' }), 2000);
    // A debug action on a debug page: it may discard unsent trees on purpose
    this.dbService.deleteDb(true);
    await this.dbService.openDb();
    this.setState({
      storageData: navigator.storage && await navigator.storage.estimate(),
      progress: undefined,
      mediaData: undefined,
      nbRecords: 0,
    })
  }

  getStorageHtml() {
    const { storageData } = this.state;

    if (!storageData) {
      return <div>unavailable</div>
    }

    return (
      <div>
        <div>quota: <strong>{storageData.quota && filesize(storageData.quota)}</strong></div>
        <div>usage: <strong>{storageData.usage && filesize(storageData.usage)}</strong></div>
        {storageData.usageDetails && storageData.usageDetails.caches &&
          <div style={{ paddingLeft: '10px' }}>
            caches: <strong>{storageData?.usageDetails?.caches && filesize(storageData?.usageDetails?.caches)}</strong>
          </div>
        }
        {storageData.usageDetails && storageData.usageDetails.indexedDB &&
          <div style={{ paddingLeft: '10px' }}>
            indexedDB: <strong>{storageData?.usageDetails?.indexedDB && filesize(storageData?.usageDetails?.indexedDB)}</strong>
          </div>
        }
        {storageData.usageDetails && storageData.usageDetails.serviceWorkerRegistrations &&
          <div style={{ paddingLeft: '10px' }}>
            serviceWorkerRegistrations: <strong>{storageData?.usageDetails?.serviceWorkerRegistrations && filesize(storageData?.usageDetails?.serviceWorkerRegistrations)}</strong>
          </div>
        }
      </div>
    );
  }

  render() {
    const { showMedia, mediaData, nbImages, nbRecords, progress, error } = this.state;

    return (
      <div style={{ padding: '20px', display: "block" }}>
        <h3>Parameters</h3>
        <p>
          {error && <div style={{ color: 'red' }}>{error}</div>}
          <div style={{ padding: '5px' }}>
            Number of images&nbsp;
            <input
              onChange={(event: any) => this.setState({ nbImages: event.target.value })}
              type='number'
              style={{ width: '40px', textAlign: 'center' }}
              value={nbImages}
            />
          </div>
          <div style={{ padding: '5px' }}>
            <button onClick={this.fetchImages}>Fetch</button>
            &nbsp;&nbsp;
            <button onClick={this.resetDb}>Clear DB</button>
          </div>
          {progress && <div style={{ color: 'blue' }}>{progress}</div>}
        </p>
        <h3>Storage</h3>
        {this.getStorageHtml()}
        <br/>
        <h3>Images</h3>
        <p>
          <div>
            <div style={{ padding: '5px' }}>
              {nbRecords} images stored in db
            </div>
            <div>
              <button onClick={this.getMediaData}>Display images</button>
            </div>
            {mediaData && mediaData.map((url: any, index: number) => {
              return (
                <div style={{ marginTop: '10px' }} key="testdiv">
                  <div>Image {index}</div>
                  {showMedia && mediaData && <img src={url} style={{ width: '90vw' }}/>}
                </div>
              )
            })}
          </div>
        </p>
      </div>

    );
  }
}